export const infoInlineRow = {
  display: 'inline-flex',
  alignItems: 'center',
};
